var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.8 252.1c-3.2 0-6.3-1.4-8.5-3.8-3.3-3.7-81.7-91.2-81.7-154 0-49.8 40.5-90.2 90.2-90.2S217 44.6 217 94.3c0 62.8-78.4 150.3-81.7 154-2.2 2.5-5.2 3.8-8.5 3.8m0-225.1c-37.1 0-67.3 30.2-67.3 67.2 0 43 47.5 104.9 67.3 128.8 19.8-23.9 67.3-85.7 67.3-128.7 0-37.1-30.2-67.3-67.3-67.3m0 111.6c-24.4 0-44.3-19.9-44.3-44.3S102.4 50 126.8 50s44.3 19.9 44.3 44.3-19.9 44.3-44.3 44.3m0-65.6c-11.8 0-21.4 9.6-21.4 21.4s9.6 21.4 21.4 21.4 21.4-9.6 21.4-21.4S138.6 73 126.8 73"
  })));
};
export default SvgLocation;